<template>
  <div>
    <v-text-field ref="field" v-model="textValue" :disabled="disabled" :label="label" @blur="onBlur" :error-messages="errorMsg" :readonly="readonly" :hint="hint"> </v-text-field>
  </div>
</template>

<script>
  import moment from 'moment';

  export default {
    name: 'GatDateEdit',
    props:['value','label','disabled','readonly','hint'],
    components: {},
    data: function() {
      return	{
          textValue:"",
          dateFormat:"DD.MM.YYYY",
          dateValue: null,
          errorMsg:[],
      }
    },

    watch:{
      value(newValue){
        this.setValueFromOutside(newValue);
      }
    },

    methods:{
      //set date from outside the component via v-model
      setValueFromOutside(value){
        let date = moment(value);
        if(date.isValid()){
          this.setDateValue(date.toDate());
        } else{
          this.setDateValue(null);
        }
      },

      dateIsDifferent(date1,date2){
        let result = false;
        if(date1==date2){
          return true;
        } else{
          let str1 = "";
          if(date1){
            str1 = date1.toISOString();
          }

          let str2 = "";
          if(date2){
            str2 = date2.toISOString();
          }
          result = str1!=str2;
        }
        return result;
      },

      //set date value
      setDateValue(value){
        if(this.dateIsDifferent(value,this.dateValue)){
          this.dateValue = value;
          this.setTextFromDate(value);
          this.$emit('input',value);
        }
      },

      //set the text from a date value
      setTextFromDate(value){
        if(value==null){
          this.textValue = null;
        } else{
          this.textValue = moment(value).format(this.dateFormat);
        }

      },

      //on blur, focus leaving edit
      onBlur(){
        let date = this.textToDate(this.textValue);
        if( moment(date).isValid()){
          this.setDateValue(date);
        }else{
          this.setDateValue(null);
        }
      },

      textToDate(text){
        let date = null;
        if(text!==""){
          date = moment.utc(text,this.dateFormat).toDate();
        }
        return date;
      },


    },


  }
</script>


<style scoped>

</style>
